<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h2>{{$t('targetWeightloss.subtitle') + $store.state.form.resultJson.userInfos.firstname + ' ' +$store.state.form.resultJson.userInfos.lastname}}</h2>
        <h1>{{$t('targetWeightloss.title')}}</h1>
      </div>
    </div>
    <div class="row ">
      <div class="col">
        <div class="row">
          <div class="col">
            <vue-slider v-if="isActivated === true" ref="sliderWeight" class="sliderComponent" v-bind="options" v-model="targetWeight"
                        v-on:drag-start="$store.commit('form/SLIDER_DRAG_EVENT', true)" v-on:drag-end="$store.commit('form/SLIDER_DRAG_EVENT', false)">
                <template slot="tooltip" slot-scope="{ value }">
                  <div class="diy-tooltip" style="color: #FFFFFF; position: relative; bottom:43px">
                    {{ value }}
                  </div>
                </template>
              <template slot="label" slot-scope="{ label, active }">
                <span :class="['custom-label', { active }]" v-if="label % 5 === 0 && label !== 0" style="position: relative; top:40px; color : #909090">
                  {{ label }}{{ weight }}
                </span>
              </template>
            </vue-slider>
          </div>
        </div>
        <div class="row">
          <div class="col overFooter">
            <button type="submit" class="btn btn-primary alignRight bg-color" @click="saveData()">{{$t('general.next')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
export default {
  name: 'numbered-goal',
  components: {
    vueSlider
  },
  data () {
    return {
      weight: this.$store.state.config.mainconfig.weight,
      isActivated: true,
      targetWeight: 0,
      options: {
        dotSize: 50,
        min: 0,
        max: 25,
        piecewiseLabel: true,
        tooltipDir: 'bottom',
        sliderStyle: [
          {
            'backgroundColor': '#96C13C'
          },
          {
            'backgroundColor': '#96C13C'
          }
        ],
        processStyle: {
          'backgroundColor': 'unset'
        }
      }
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'TargetWeightloss', isAuthorized: true, data: this.dataTosave});
  },
  deactivated: function () {
    this.isActivated = false;
  },
  activated: function () {
    this.isActivated = true;
  },
  methods: {
    saveData: function () {
      this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
    }
  },
  computed: {
    dataTosave: function () {
      return {
        targetWeightloss: {
          targetWeight: this.targetWeight
        }
      };
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/layouts/TargetWeightloss.vue